export const REMOVE_VEHICLE_JSON_MAP = {
  firstName: 'First Name',
  lastName: 'Last Name',
  policyNumber: 'Policy Number',
  phoneNumber: 'Phone Number',
  streetAddress: 'Street Address',
  zipCode: 'Zip Code',
  emailAddress: 'Email Address',
  vehicleInfo: {
    vin: 'VIN',
    year: 'YEAR',
    make: 'MAKE',
    model: 'MODEL'
  },
  reason: 'What is the primary reason for removing this vehicle',
  effectDate: 'What date would you like this change to go into effect?'
}
